import React, { useState } from 'react';
import Button from '../ui/Button';
import Icon from '../AppIcon';
import { useClickOutside } from '../../hooks/useClickOutside';

const SimpleHiringActions = ({ interview, onStatusChange, loading }) => {
  const [showActions, setShowActions] = useState(false);
  const dropdownRef = useClickOutside(() => setShowActions(false), showActions);

  const getStatusDisplay = (status) => {
    switch (status) {
      case 'interviewed': return { label: 'Interviewed', color: 'blue', icon: 'MessageSquare' };
      case 'under_consideration': return { label: 'Under Consideration', color: 'amber', icon: 'Clock' };
      case 'hired': return { label: 'Hired', color: 'green', icon: 'UserCheck' };
      case 'not_moving_forward': return { label: 'Not Moving Forward', color: 'red', icon: 'X' };
      default: return { label: 'Interviewed', color: 'blue', icon: 'MessageSquare' };
    }
  };

  const status = getStatusDisplay(interview.hiring_status || 'interviewed');

  const quickActions = [
    {
      id: 'under_consideration',
      label: 'Move to Consideration',
      icon: 'Clock',
      color: 'amber',
      description: 'Review for potential hire'
    },
    {
      id: 'hired',
      label: 'Mark as Hired',
      icon: 'UserCheck', 
      color: 'green',
      description: 'Candidate was hired'
    },
    {
      id: 'not_moving_forward',
      label: 'Not Moving Forward',
      icon: 'X',
      color: 'red',
      description: 'Not proceeding with candidate'
    }
  ];

  const availableActions = quickActions.filter(action => {
    const currentStatus = interview.hiring_status || 'interviewed';
    if (currentStatus === 'hired' || currentStatus === 'not_moving_forward') return false;
    if (action.id === currentStatus) return false;
    return true;
  });

  return (
    <div className="flex items-center space-x-3">
      {/* Current Status Badge */}
      <span className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium ${
        status.color === 'blue' ? 'bg-blue-100 text-blue-800' :
        status.color === 'amber' ? 'bg-amber-100 text-amber-800' :
        status.color === 'green' ? 'bg-green-100 text-green-800' :
        'bg-red-100 text-red-800'
      }`}>
        <Icon name={status.icon} size={14} className="mr-1" />
        {status.label}
      </span>

      {/* Quick Actions */}
      {availableActions.length > 0 && (
        <div className="relative" ref={dropdownRef}>
          <Button
            variant="outline"
            size="sm"
            iconName="MoreHorizontal"
            onClick={() => setShowActions(!showActions)}
            disabled={loading}
          >
            Update Status
          </Button>

          {showActions && (
            <div className="absolute right-0 mt-2 w-56 bg-white rounded-lg shadow-lg border border-gray-200 z-10">
              <div className="py-2">
                {availableActions.map((action) => (
                  <button
                    key={action.id}
                    onClick={() => {
                      onStatusChange(interview.id, action.id);
                      setShowActions(false);
                    }}
                    className="w-full px-4 py-3 text-left hover:bg-gray-50 flex items-start space-x-3"
                    disabled={loading}
                  >
                    <Icon 
                      name={action.icon} 
                      size={16} 
                      className={`mt-0.5 ${
                        action.color === 'amber' ? 'text-amber-600' :
                        action.color === 'green' ? 'text-green-600' :
                        'text-red-600'
                      }`} 
                    />
                    <div>
                      <div className="font-medium text-gray-900">{action.label}</div>
                      <div className="text-sm text-gray-500">{action.description}</div>
                    </div>
                  </button>
                ))}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default SimpleHiringActions;
